













import SwitchByUa from '@/components/atoms/SwitchByUa.vue'
import { log } from '@/log'
import { ApiContent } from '@/models/api/content'
import FreeAreaService from '@/services/free-area/free-area'
import {
  SelectPaidMembershipPlanFreeArea
} from '@/services/free-area/paid-membership/select-paid-membership-plan-free-area'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

interface FreeArea {
  description: ApiContent | null
}

@Component({
  components: {
    SwitchByUa,
  },
})
export default class DescriptionOfPlans extends Vue {
  @Prop({
    default: () => FreeAreaService.createForHost(SelectPaidMembershipPlanFreeArea),
  })
  readonly freeAreaService: SelectPaidMembershipPlanFreeArea

  freeArea: FreeArea = {
    description: null,
  }

  created() {
    this.freeAreaService.fetch().then((contents) => {
      const [description] = contents

      this.freeArea = {
        description: description || ApiContent.empty,
      }
    }).catch((error) => {
      log.warn(error, 'any contents of free areas not found, so filled them by empty content')

      this.freeArea = {
        description: ApiContent.empty,
      }
    })
  }
}
